import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EstimateService } from 'src/app/services/estimate.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { MapInformationService } from 'src/app/services/map-information.service';
import { GoogleAuthService } from 'src/app/services/google-auth.services';
import { ToastService } from 'ng-uikit-pro-standard';

import { TranslateService } from '@ngx-translate/core';
declare var $: any;
import { SignaturePad } from 'angular2-signaturepad';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-services',
  templateUrl: './account-services.component.html',
  styleUrls: ['./account-services.component.scss']
})
export class AccountAndServicesComponent implements OnInit {
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;

  signaturePadOptions: any = { // passed through to szimek/signature_pad constructor
    minWidth: 2,
    canvasWidth: '525',
    canvasHeight: '160',
    backgroundColor: '#f5f5f5'
  };
  settings: any = {};

  today = new Date().getTime();
  millisecondsInDay = 24 * 60 * 60 * 1000;
  birthDate: any = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };
  hireDateDate: any = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };
  terminationDate: any = { todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today };

  requestString = '';
  _data: any[] = [];
  tempArray = [];
  newTempArray = [];
  arrayOfSignature = [];

  employeeForm: FormGroup = new FormGroup({
    EmployeeNumber: new FormControl('', [Validators.required]),
    FirstName: new FormControl('', [Validators.required]),
    LastName: new FormControl(null, [Validators.required]),
    BirthDate: new FormControl(null, [Validators.required]),
    Department: new FormControl(null, [Validators.required]),
    JobCode: new FormControl(null, [Validators.required]),
    Supervisor: new FormControl(null, [Validators.required]),
    EmploymentType: new FormControl(null, [Validators.required]),
    Active: new FormControl(null, []),
    MobilePhone: new FormControl(null, [Validators.required]),
    Email: new FormControl(null, [Validators.required]),
    EmergencyContactName: new FormControl(null, [Validators.required]),
    EmergencyContactNumber: new FormControl(null, [Validators.required]),
    Address: new FormControl(null, [Validators.required]),
    HireDate: new FormControl(null, []),
    TerminationDate: new FormControl(null, []),
    title: new FormControl(null, []),
    regionid: new FormControl(null, []),
    SIGNATURE: new FormControl(null, []),
    BASE64SIGNATURE: new FormControl(null, []),
    CERTIFICATION: new FormControl(null, []),
    EmailUsername: new FormControl('', []),
    Password: new FormControl('', []),
    EmailIntegration: new FormControl('', [Validators.email]),
  })

  jobCode: any = [];
  supervisors: any = [];
  departments: any = [];
  regionsSelect: any = [];
  employmentType: any = [];

  employeeid: any;
  infoEmpleado: any;

  services = [];
  serviceOptions = ['Smtp', 'Google', 'Microsoft'];
  // serviceOptions = ['Smtp'];
  selectedServiceType: string = 'Smtp';
  showNewServiceModal = false;
  showNewServicePopup = false;

  newServiceForm: FormGroup = new FormGroup({
    id: new FormControl(0, []),
    smtpUsername: new FormControl('', [Validators.required]),
    sendedFrom: new FormControl('', [Validators.required]),
    smtpEmailServer: new FormControl('', [Validators.required]),
    smtpPassword: new FormControl('', [Validators.required]),
    is_default: new FormControl('', []),
  });

  errorPopupVisible: boolean = false;
  errorMessage: string = '';
  successPopupVisible: boolean = false;
  tokeGoogle: string;
  datasourceResources2: any;

  constructor(
    private location: Location,
    private datepipe: DatePipe,
    private toast: ToastService,
    private appconfig: AppConfigService,
    private estimateService: EstimateService,
    private employeesService: EmployeesService,
    private MapInformationService: MapInformationService,
    private translate: TranslateService,
    private googleAuth: GoogleAuthService,
    private activatedRoute: ActivatedRoute,

  ) {
    this.settings.dateFormat = this.appconfig.dateFormat;
    this.employeeid = localStorage.getItem('customerid');
    this.tokeGoogle = activatedRoute.snapshot.queryParamMap.get("token");

    localStorage.setItem('tokenGoogle', this.tokeGoogle);
  }

  ngOnInit() {
    // await this.googleAuth.initClient();
    // this.getDataEmployee();
    this.getDataToservices();
    this.gettokenNew();

    this.validateToken();

    this.GetResources2();



  }

  isLoggedGoogle: boolean = false;
  validateToken() {
    // this.MapInformationService.getUserGoogleValidation().subscribe(res => {
    //   if (!res['hasToken']) {
    //     this.isLoggedGoogle = false;
    //   } else {
    //     this.isLoggedGoogle = true;
    //   }
    // })
  }



  // getDataEmployee() {
  //   this.MapInformationService.SaveInfoSites({ method: "Get_EmployeeListById", id: this.employeeid })
  //     .subscribe(infoEmpleado => {
  //       console.log('Data Employee ', infoEmpleado[0]);
  //       this.infoEmpleado = infoEmpleado[0];

  //       this.inputsDate(this.birthDate, this.infoEmpleado.BIRTHDAY);
  //       this.inputsDate(this.hireDateDate, this.infoEmpleado.HIREDATE);
  //       this.inputsDate(this.terminationDate, this.infoEmpleado.TERMINATIONDATE);
  //       this.getDataToservices();

  //       this.employeeForm = new FormGroup({
  //         EmployeeNumber: new FormControl(this.infoEmpleado.EMPNUMBER, [Validators.required]),
  //         FirstName: new FormControl(this.infoEmpleado.FIRSTNAME, [Validators.required]),
  //         LastName: new FormControl(this.infoEmpleado.LASTNAME, [Validators.required]),
  //         BirthDate: new FormControl(this.birthDate.showDate, [Validators.required]),
  //         Department: new FormControl(this.infoEmpleado.DEPARTMENTID, [Validators.required]),
  //         JobCode: new FormControl(null, [Validators.required]),
  //         Supervisor: new FormControl(this.infoEmpleado.SUPERVISOR, [Validators.required]),
  //         EmploymentType: new FormControl(this.infoEmpleado.EMPLOYEMNTTYPEID, [Validators.required]),
  //         Active: new FormControl(this.infoEmpleado.ACTIVE, []),
  //         MobilePhone: new FormControl(this.infoEmpleado.MOBILEPHONE, [Validators.required]),
  //         Email: new FormControl(this.infoEmpleado.EMAIL, [Validators.required]),
  //         EmergencyContactName: new FormControl(this.infoEmpleado.EMERGENCYCONTACT, [Validators.required]),
  //         EmergencyContactNumber: new FormControl(this.infoEmpleado.EMRGENCYPHONE, [Validators.required]),
  //         Address: new FormControl(this.infoEmpleado.HOMEADDRESS, [Validators.required]),
  //         HireDate: new FormControl(this.hireDateDate.showDate, []),
  //         TerminationDate: new FormControl(this.terminationDate.showDate, []),
  //         title: new FormControl(this.infoEmpleado.TITLE, []),
  //         regionid: new FormControl(this.infoEmpleado.REGIONID, []),
  //         SIGNATURE: new FormControl(this.infoEmpleado.SIGNATURE, []),
  //         BASE64SIGNATURE: new FormControl(this.infoEmpleado.BASE64SIGNATURE, []),
  //         CERTIFICATION: new FormControl(this.infoEmpleado.CERTIFICATION, []),
  //         EmailUsername: new FormControl(this.infoEmpleado.EMAILUSERNAME, [Validators.email]),
  //         Password: new FormControl(this.infoEmpleado.EMAILPASSWORD, []),
  //         EmailIntegration: new FormControl(this.infoEmpleado.EMAILSERVER, []),
  //       })

  //       if (this.infoEmpleado.JOBCODE == undefined) {
  //         this.employeeForm.get("JobCode").setValue("4")
  //       } else {
  //         this.employeeForm.get("JobCode").setValue(this.infoEmpleado.JOBCODE)
  //       }

  //       console.log(this.employeeForm.value)

  //       this.showSignature([{ SIGNCAPTURE: this.infoEmpleado.SIGNATURE }]);

  //       this.getDepartments();
  //       this.getJobCode();
  //       this.getSupervisors();
  //       this.getEmploymentType();
  //       this.getRegions();
  //     })
  // }

  //Listas de Form

  getDepartments() {
    this.employeesService.GetDepartments().subscribe(async result => {
      this.departments = await result.map((val) => {
        return {
          name: val.NAME,
          id: val.ID
        }
      })
    })
  }

  getJobCode() {
    this.employeesService.GetJobCode().subscribe(async result => {
      this.jobCode = await result.map((val) => {
        return {
          id: val.ID,
          name: val.DESCRIPTION
        }
      });
    })
  }

  getSupervisors() {
    this.employeesService.GetSupervisor().subscribe(result => {
      this.supervisors = result.map((val) => {
        return {
          id: val.ID,
          name: val.CONTACTNAME
        }
      });
    })
  }

  getEmploymentType() {
    this.employeesService.GetEmploymentType().subscribe(result => {

      this.employmentType = result.map((val, i) => {
        if (this.infoEmpleado.EMPLOYEMNTTYPEID == null && i == 0) {
          this.employeeForm.get('EmploymentType').setValue(val.ID);
        }
        return {
          id: val.ID,
          name: val.EMPLOYMENTTYPE
        }
      });
    })
  }

  getRegions() {
    this.estimateService.Get_ProjectRegionID('dummyData').subscribe(result => {
      this.regionsSelect = result.map(x => {
        x.value = x.Id;
        x.label = x.DivisionName;
        return x;
      });
    })
  }


  // $$_Gdi_$$
  save() {
    let form = this.employeeForm.value;

    console.log('THE FORM');
    console.log(form);

    let date = ""
    if (form.BirthDate != undefined && form.BirthDate != "") {
      date = this.datepipe.transform(new Date(form.BirthDate), 'yyyyMMdd')
    } else if (form.BirthDate != "") {
      date = this.datepipe.transform(new Date(form.BirthDate), 'yyyyMMdd')
    }

    let date1 = ""
    if (form.HireDate != undefined && form.HireDate != "") {
      date1 = this.datepipe.transform(new Date(form.HireDate), 'yyyyMMdd')
    }

    let date2 = ""
    if (form.TerminationDate != undefined && form.TerminationDate != "") {
      date2 = this.datepipe.transform(new Date(form.TerminationDate), 'yyyyMMdd')
    }
    form.Active == false ? form.Active = 0 : form.Active = 1;

    if (form.EmploymentType == "" || form.EmploymentType == undefined) {
      form.EmploymentType = 0
    }



    const json = this.getJson();

    var SignJson = '[' + this.requestString + ']';

    form.signature = SignJson;
    form.basesignature = this.signaturePad.toDataURL();



    this.employeesService.UpdateEmployeeNew(
      form.FirstName, form.LastName, form.Email, form.Active, form.MobilePhone,
      form.EmergencyContactNumber, form.EmergencyContactName, form.Address, this.infoEmpleado.ID, form.JobCode, form.Department,
      form.EmploymentType, form.Supervisor, form.EmployeeNumber, date, date1, date2, form.title, form.regionid,
      form.signature, form.basesignature, form.CERTIFICATION, form.EmailUsername, form.Password == '!password###' ? null : form.Password,
      form.EmailIntegration).subscribe(result => {
        this.toast.success('Data was saved.');
        this.translate.instant(this.translate.instant('msgUpdSucc'));
      })
  }

  clear() {
    console.log('Clear');
    this.signaturePad.clear()
  }

  goBack() {
    this.location.back();
  }

  inputsDate(date, showdate) {
    if (showdate !== null) {
      let year = this.datepipe.transform(showdate, 'yyyy');
      date.showDate = parseInt(year) < 1990 ? new Date().getTime() : new Date(showdate).getTime();
    } else {
      date.showDate = new Date().getTime();
    }

    date.todayButton = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        date.showDate = new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate = date.showDate == null ? new Date().getTime() - this.millisecondsInDay : date.showDate - this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate = date.showDate == null ? new Date().getTime() + this.millisecondsInDay : date.showDate + this.millisecondsInDay;
      }
    };
  }

  showSignature(datos) {
    this._data = []
    // if (this.signature.length != 0) {
    // this.approvedBy = this.signatureDetails.SERVICEAPPROVEDBY;
    // this.signature = this.signature.substr(9, this.signature.length).substr(0, this.signature.length - 10);
    if (datos[0].SIGNCAPTURE != undefined) {
      const str = datos[0].SIGNCAPTURE
      try {
        const obj = JSON.parse(str);

        for (let i = 0; i < obj.length; i++) {
          this._data.push([]);
          for (let j = 0; j < obj[i].length; j++) {
            this._data[i].push({
              x: (obj[i][j][0]),
              y: (obj[i][j][1]),
              color: 'black',
              time: 0
            });
          }
        }
      } catch (error) {
        this.toast.error('Error with signature. Clear and try again.');
      }
      // }

      setTimeout(() => {
        this.signaturePad.fromData(this._data);
      }, 500);
    }
  }


  getJson() {

    if (this.signaturePad.toData().length > 0) {

      this.tempArray = this.signaturePad.toData();

      console.log(this.tempArray);
      this.newTempArray = this.signaturePad.toData();
      this.requestString = '';
      try {
        for (let i = 0; i < this.tempArray.length; i++) {
          this.requestString += '[';
          for (let j = 0; j < this.tempArray[i].length; j++) {
            if (j == this.tempArray[i].length - 1) {
              this.requestString += ('[' + this.tempArray[i][j].x.toString() + ',' + this.tempArray[i][j].y.toString() + ']');
            }
            else {
              this.requestString += ('[' + this.tempArray[i][j].x.toString() + ',' + this.tempArray[i][j].y.toString() + '],');
            }
          }
          if (i == this.tempArray.length - 1) {
            this.requestString += ']';
          } else {
            this.requestString += '],';
          }

        }
        // alert(this.requestString)
        // this.saveSig();
      } catch (Ex) {
        // this.toast.(Ex.toString());
        ////////////////////////////////////////////
        for (let i = 1; i < this.tempArray.length; i++) {
          this.requestString += '[';
          for (let j = 0; j < this.tempArray[i].length; j++) {
            if (j == this.tempArray[i].length - 1) {
              this.requestString += ('[' + this.tempArray[i][j].x.toString() + ',' + this.tempArray[i][j].y.toString() + ']');
            } else {
              this.requestString += ('[' + this.tempArray[i][j].x.toString() + ',' + this.tempArray[i][j].y.toString() + '],');
            }
          }
          this.requestString += this.arrayOfSignature.toString();
          if (i == this.tempArray.length - 1) {
            this.requestString += ']';
          }
          else {
            this.requestString += '],';
          }

        }
        // this.saveSig();
      }
    } else {
      // this.toast.error('Please sign');
      this.requestString = ''
      return null;
    }
    return this.requestString;
  }


  connectGoogle() {
    console.log('Connect Google');
  }


  // Email Integration (Google)
  user: any;

  async loginWithGoogle() {
    this.user = await this.googleAuth.signIn();
  }

  async verEmails() {
    const accessToken = this.user.getAuthResponse().access_token;
    console.log('Access Token:', accessToken);
    const res = await fetch('https://gmail.googleapis.com/gmail/v1/users/me/messages', {
      headers: { Authorization: `Bearer ${accessToken}` }
    });
    const data = await res.json();
    console.log(data);
  }

  loginWithMicrosoft() {
    const clientId = 'TU_CLIENT_ID';
    const redirectUri = encodeURIComponent('http://localhost:4200');
    const scopes = encodeURIComponent('openid profile User.Read Mail.Send');
    const state = '12345';
    const url = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=token&redirect_uri=${redirectUri}&scope=${scopes}&response_mode=fragment&state=${state}`;
    window.location.href = url;

  }

  openNewServiceModal() {
    this.showNewServicePopup = true;
    this.selectedServiceType = '';
    this.newServiceForm.reset();
    this.selectedServiceType = 'Smtp';
    this.selectedConnectionType = 'google';
    setTimeout(() => {
      this.newServiceForm.get('sendedFrom').setValue(localStorage.getItem('userName'));
    }, 500);
  }

  closeNewServiceModal() {
    this.showNewServicePopup = false;
  }

  openNewServicePopup() {
    this.showNewServicePopup = true;
    this.selectedServiceType = '';
    this.newServiceForm.reset();
  }

  closeNewServicePopup() {
    this.showNewServicePopup = false;
  }

  onServiceTypeChange(event: any) {
    this.selectedServiceType = event.value;

    if (this.selectedServiceType === 'Google') {
      this.getUserGoogleToken();
    }
  }

  saveNewService() {

    console.log('New Service Form Value:', this.newServiceForm.get('smtpUsername').value);
    console.log(this.services)

    let saveData = true

    if (this.newServiceForm.get('id').value == undefined || this.newServiceForm.get('id').value == 0) {
      this.services.forEach(service => {
        if (service.username == this.newServiceForm.get('smtpUsername').value) {
          this.toast.warning('This email is already registered in another service.');
          saveData = false;
        }
      })
    }



    if (saveData) {
      if (this.selectedServiceType === 'Smtp' && this.newServiceForm.valid) {
        const passwordNew = this.newServiceForm.get('smtpPassword').value == this.passwordTemporary ? "!password###" : this.newServiceForm.get('smtpPassword').value;
        const newService = {
          id: this.newServiceForm.get('id').value == undefined ? 0 : this.newServiceForm.get('id').value,
          method: "Save_EMPLOYEE_EMAIL_CONNECTIONS",
          employeeid: this.employeeid,
          conn_type: 'smtp',
          data: this.newServiceForm.get('smtpUsername').value + "[+]" + passwordNew + "[+]" + this.newServiceForm.get('smtpEmailServer').value + "[+]" + this.newServiceForm.get('sendedFrom').value,
          is_default: this.newServiceForm.get('is_default').value ? 1 : 0,
        };
        this.MapInformationService.SaveInfoSites(newService).subscribe(result => {

          if (this.services.length === 0) {
            this.toast.success('SMTP Service saved successfully.');
            this.closeNewServiceModal();
            this.getDataToservices();

          } else {
            let contador = 0;
            this.services.forEach(service => {
              if (this.newServiceForm.get('id').value == undefined || this.newServiceForm.get('id').value == 0) {

                if (this.newServiceForm.get('is_default').value == true) {
                  this.MapInformationService.SaveInfoSites({
                    method: "Save_EMPLOYEE_EMAIL_CONNECTIONS",
                    id: service.id,
                    is_default: 0,
                    // employeeid: this.employeeid
                  }).subscribe(() => {
                    contador++;
                    if (contador === this.services.length) {
                      this.toast.success('SMTP Service saved successfully.');
                      this.closeNewServiceModal();
                      this.getDataToservices();
                    }
                  }, error => {
                    console.error(`Error updating service with id ${service.id}`, error);
                  });
                } else {
                  contador++;
                  if (contador === this.services.length) {
                    this.toast.success('SMTP Service saved successfully.');
                    this.closeNewServiceModal();
                    this.getDataToservices();
                  }
                }


              } else {
                if (service.id !== this.newServiceForm.get('id').value && this.newServiceForm.get('is_default').value == true) {
                  this.MapInformationService.SaveInfoSites({
                    method: "Save_EMPLOYEE_EMAIL_CONNECTIONS",
                    id: service.id,
                    is_default: 0,
                    // employeeid: this.employeeid
                  }).subscribe(() => {
                    contador++;
                    if (contador === this.services.length) {
                      this.toast.success('SMTP Service saved successfully.');
                      this.closeNewServiceModal();
                      this.getDataToservices();
                    }
                  }, error => {
                    console.error(`Error updating service with id ${service.id}`, error);
                  });
                } else {
                  contador++;
                  if (contador === this.services.length) {
                    this.toast.success('SMTP Service saved successfully.');
                    this.closeNewServiceModal();
                    this.getDataToservices();
                  }
                }
              }

            });
          }
        })

      } else if (this.selectedServiceType !== 'Smtp') {
        const newService = {
          id: this.services.length + 1,
          type: this.selectedServiceType,
          username: '',
          emailServer: '',
        };
        this.services.push(newService);
        this.closeNewServiceModal();
      } else {
        this.toast.warning('Please fill in all required fields for SMTP service.');
      }
    }

  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      template: 'buttonsRight'
    });
    e.toolbarOptions.items.unshift({
      location: 'before',
      template: 'buttonsLeft'
    });
  }

  getDataToservices() {
    this.MapInformationService.SaveInfoSites({ method: "Get_EMPLOYEE_EMAIL_CONNECTIONS", employeeid: this.employeeid })
      .subscribe(result => {
        // Procesar los registros

        this.services = result.map(service => {
          const dataParts = service.DATA.split('[+]');
          console.log('Data Parts:', dataParts);
          return {
            id: service.ID,
            employeeId: service.EMPLOYEEID,
            connType: service.CONN_TYPE,
            username: dataParts[0] || '',
            password: dataParts[1] || '',
            emailServer: dataParts[2] || '',
            sendedFrom: dataParts[3] || '',
            is_default: service.IS_DEFAULT,
            Allowed: service.Allowed,
            AllowedId: service.AllowedId
          };
          return service; // Devolver el registro sin cambios si no es `smtp`
        });

        console.log('Processed Services:', this.services);
      });
  }

  passwordTemporary: string = '';

  edit(data) {
    console.log('Edit Service Data:', data);
    this.selectedServiceType = 'Smtp';
    this.newServiceForm.get('id').setValue(data.id);
    this.newServiceForm.get('smtpUsername').setValue(data.username);
    this.newServiceForm.get('sendedFrom').setValue(data.sendedFrom);
    this.newServiceForm.get('smtpEmailServer').setValue(data.emailServer);
    this.newServiceForm.get('smtpPassword').setValue(data.password);
    this.newServiceForm.get('is_default').setValue(data.is_default);
    this.passwordTemporary = data.password
    this.showNewServicePopup = true;
  }

  selecteditem: any;
  confirmDeletePopup: boolean = false;
  showDeleteConfirmation(data) {
    this.selecteditem = data;
    this.confirmDeletePopup = true;
  }

  deleteItem() {
    console.log('Delete Service Data:', this.selecteditem);
    this.MapInformationService.SaveInfoSites({ method: "Delete_EMPLOYEE_EMAIL_CONNECTIONS", id: this.selecteditem.id })
      .subscribe(resp => {
        this.toast.success("Template deleted successfully");
        this.getDataToservices();
        this.confirmDeletePopup = false;
      }, error => {
        this.toast.error("Error deleting template");
      });
  }

  testCredencials(data) {
    console.log('Test Credentials Data:', data);

    const dataTest = {
      "subject": "Testing Credencials",
      "mailto": data.username,
      "copyemailto": "",
      "bodyhtm": "Testing Credencials",
      "senderaccountid": data.id
    }

    this.MapInformationService.EmailDinamic(dataTest).subscribe(
      (res: any) => {
        console.log('Email sent successfully:', res);
        this.successPopupVisible = true;
      },
      (error: any) => {
        console.error('Error sending email:', error);
        this.errorMessage = 'Error sending email: ' + error.details;
        this.errorPopupVisible = true;
      }
    );
  }

  ModifyDefault(event, data) {
    console.log('Modify Default Service:', event);

    // Actualizar el servicio seleccionado
    this.MapInformationService.SaveInfoSites({
      method: "Save_EMPLOYEE_EMAIL_CONNECTIONS",
      id: data.id,
      is_default: event.value ? 1 : 0,
      // employeeid: this.employeeid
    }).subscribe(resp => {
      this.toast.success("Default service modified successfully");

      // Actualizar los demás servicios para que no sean predeterminados
      let contador = 0;
      this.services.forEach(service => {
        if (service.id !== data.id) {
          this.MapInformationService.SaveInfoSites({
            method: "Save_EMPLOYEE_EMAIL_CONNECTIONS",
            id: service.id,
            is_default: 0,
            // employeeid: this.employeeid
          }).subscribe(() => {
            contador++;
            if (contador === this.services.length) {
              this.getDataToservices();
            }
          }, error => {
            console.error(`Error updating service with id ${service.id}`, error);
          });
        } else {
          contador++;
          if (contador === this.services.length) {
            this.getDataToservices();
          }
        }
      });


    }, error => {
      this.toast.error("Error modifying default service");
    });
  }


  getUserGoogleToken() {
    this.MapInformationService.getUserGoogleToken();
  }


  gettokenNew() {
    console.log(this.tokeGoogle)
  }

  selectedConnectionType: string = '';
  selectConnectionType(type: string) {
    this.selectedConnectionType = type;
  }


  connectGoogleAccount() {

    // this.MapInformationService.getUserGoogleValidation().subscribe(res => {
    //   console.log(res);

    //   if (!res['hasToken']) {
        this.MapInformationService.getUserGoogleToken();
    //   } else {
    //     this.toast.success('Google account connected successfully');
    //     this.selectedConnectionType = '';
    //   }
    // })


  }

  connectMicrosoftAccount() {
    this.selectedConnectionType = 'microsoft';
  }


  defaultSendTo:any[] = [];

  GetResources2() {
    this.MapInformationService.GetAllInfo('Get_EmployeeListAll') //Get_EmployeeListAll
      .subscribe(resources => {
        this.datasourceResources2 = resources
      })
  }

  contentReady(item) {
    // console.log(item)
  }


  SaveNewResources(e) {
    console.log(e)
    if (e.changes.length > 0) {



      if (e.changes[0].data.Allowed && e.changes[0].data.Allowed.length != 0) {
        
        console.log(e.changes[0].data)
        
        e.changes[0].data.Allowed = e.changes[0].data.Allowed.join(',');
        
        const data = {
          method: 'SaveEmailAccountPermissions',
          employeeids: e.changes[0].data.Allowed,
          id: e.changes[0].data.id
        }

        console.log(data)

        this.MapInformationService.SaveInfoSites(data)
          .subscribe(resp => {
            console.log(resp)
            this.getDataToservices();
            this.toast.success("Update success.");
          })
      } else {
        this.getDataToservices();
        this.toast.success("Update success.");
      }

    }
  }


  Test(e) {
    console.log("🚀 ~ CompanyNotificationComponent ~ Test ~ e:", e)
    this.defaultSendTo = [];

    if (e.data.AllowedId != null && e.data.AllowedId.length > 0) {

      console.log("🚀 ~ CompanyNotificationComponent ~ Test ~ e.data.AllowedId:", e.data.AllowedId)

      let dataTempo = []
      e.data.AllowedId.split(',').forEach((ids) => {
        // this.defaultSendTo.push(parseInt(ids));
        dataTempo.push(parseInt(ids));
      })

      this.defaultSendTo = dataTempo;

      console.log("🚀 ~ testing:", this.datasourceResources2)

    }
    console.log("🚀 ~ CompanyNotificationComponent ~ Test ~ this.defaultSendTo:", this.defaultSendTo)

  }

  Test2() {
  }

  allowUpdating(e) {
    // Si employeeId es 0, no permitir edición
    return e.row.data.employeeId !== 0;
  }


}
